//changed due to package upgrade
import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import {
  alpha,
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import Grid from '@mui/material/Grid';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import jwtAxios from '@projectK/services/auth/JWT';
import PropTypes from 'prop-types';
import { useInfoViewActionsContext } from '@projectK/context';
import AppInfoView from '@projectK/components/AppInfoView';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import { hasPermission,useRolePermissions } from '@projectK/context/RolesProvider';
import IntlMessages from '@projectK/helpers/IntlMessages';
const MessagePreferances = ({ companyTheme }) => {
  const infoViewActionsContext = useInfoViewActionsContext();
  const { verbiageSettings } = useApplicationSettings();
  const { rolePermissions } = useRolePermissions();
  const { user } = useAuthUser();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    fetchSettings();
  }, []);
  const fetchSettings = async () => {
    try {
      const response = await jwtAxios.get(`/message-settings/${user.id}`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching Message settings:', error);
    }
  };

  return (
    <>
      <Box>
        <Formik
          enableReinitialize={true}
          validateOnBlur={true}
          initialValues={{
            wait_list_notification: settings?.wait_list_notification || '',
            wait_list_processed_notification:
              settings?.wait_list_processed_notification || '',
            feedback_notification: settings?.feedback_notification || '',
            attendance_notification: settings?.attendance_notification || '',
            event_cancellation: settings?.event_cancellation || '',
            event_details_changed_notification:
              settings?.event_details_changed_notification || '',
            league_invitation: settings?.league_invitation || '',
            product_invite: settings?.product_invite || '',
            purchase_receipt: settings?.purchase_receipt || '',
            notification: settings?.notification || '',
            product_message: settings?.product_message || '',
            low_credit_warning: settings?.low_credit_warning || '',
            event_reminder: settings?.event_reminder || '',
            expired_credit: settings?.expired_credit || '',
            expired_product: settings?.expired_product || '',
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            jwtAxios
              .put(`/message-settings/${user.id}`, values)
              .then((response) => {
                setSubmitting(false);
                if (response.status === 201) {
                  infoViewActionsContext.showMessage(
                    'Message Preferences Updated Successfully',
                  );
                  fetchSettings();
                } else {
                  infoViewActionsContext.showMessage(
                    'Error Updating Message Preferances ',
                  );
                }
              })
              .catch((error) => {
                setSubmitting(false);
                infoViewActionsContext.fetchError(error.response.data.error);
              });
          }}
        >
          {({ values, setFieldValue, handleChange, resetForm }) => {
            return (
              <Form noValidate autoComplete='off'>
                <Grid size={{ xs: 12, md: 12 }}>
                  <AppGridContainer>
                  <Grid size={{ xs: 12, md: 6 }}>
                  <Typography component='h3'>
                        Waitlist Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Waitlist Notification'
                        name='wait_list_notification'
                        value={values.wait_list_notification}
                        onChange={(e) => {
                          setFieldValue(
                            'wait_list_notification',
                            e.target.value,
                          );
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Confirm Waitlist Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Confirm Waitlist Notification'
                        name='wait_list_processed_notification'
                        value={values.wait_list_processed_notification}
                        onChange={(e) => {
                          setFieldValue(
                            'wait_list_processed_notification',
                            e.target.value,
                          );
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Feedback Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Feedback Notification'
                        name='feedback_notification'
                        value={values.feedback_notification}
                        onChange={(e) => {
                          setFieldValue(
                            'feedback_notification',
                            e.target.value,
                          );
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Attendance Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Attendance Notification'
                        name='attendance_notification'
                        value={values.attendance_notification}
                        onChange={(e) => {
                          setFieldValue(
                            'attendance_notification',
                            e.target.value,
                          );
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Event Cancellation</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='
                      Event Cancellation'
                        name='event_cancellation'
                        value={values.event_cancellation}
                        onChange={(e) => {
                          setFieldValue('event_cancellation', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Event Details Changed Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Event Details Changed Notification'
                        name='event_details_changed_notification'
                        value={values.event_details_changed_notification}
                        onChange={(e) => {
                          setFieldValue(
                            'event_details_changed_notification',
                            e.target.value,
                          );
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>League Invitation</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='League Invitation'
                        name='league_invitation'
                        value={values.league_invitation}
                        onChange={(e) => {
                          setFieldValue('league_invitation', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Add Member Notification
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Add Member Notification'
                        name='product_invite'
                        value={values.product_invite}
                        onChange={(e) => {
                          setFieldValue('product_invite', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Purchase Receipt</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='
                      Purchase Receipt'
                        name='purchase_receipt'
                        value={values.purchase_receipt}
                        onChange={(e) => {
                          setFieldValue('purchase_receipt', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Notification</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Notification'
                        name='notification'
                        value={values.notification}
                        onChange={(e) => {
                          setFieldValue('notification', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        {verbiageSettings.product_type || 'Product'} Message
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Product Message'
                        name='product_message'
                        value={values.product_message}
                        onChange={(e) => {
                          setFieldValue('product_message', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Low Credit Warning</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Low Credit Warning'
                        name='low_credit_warning'
                        value={values.low_credit_warning}
                        onChange={(e) => {
                          setFieldValue('low_credit_warning', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Event Reminder</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Event Reminder'
                        name='event_reminder'
                        value={values.event_reminder}
                        onChange={(e) => {
                          setFieldValue('event_reminder', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>Expired Credit</Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Expired Credit'
                        name='expired_credit'
                        value={values.expired_credit}
                        onChange={(e) => {
                          setFieldValue('expired_credit', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                    <Typography component='h3'>
                        Expired {verbiageSettings.product_type || 'Product'}
                      </Typography>
                      <RadioGroup
                        row
                        aria-labelledby='Expired Product'
                        name='expired_product'
                        value={values.expired_product}
                        onChange={(e) => {
                          setFieldValue('expired_product', e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value='none'
                          control={<Radio />}
                          label='None'
                        />
                        <FormControlLabel
                          value='email'
                          control={<Radio />}
                          label='Email'
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {hasPermission(rolePermissions, 'My Locker - Settings', 'update') && (
                        <Button
                          sx={{
                            position: 'relative',
                            minWidth: 100,
                            backgroundColor: companyTheme
                              ? companyTheme.primary.main
                              : '#2196f3',
                            '&:hover': {
                              backgroundColor: companyTheme
                                ? alpha(companyTheme.primary.main, 0.8) // Adjust the alpha value as needed
                                : alpha('#2196f3', 0.8),
                            },
                          }}
                          variant='contained'
                          type='submit'
                        >
                          Save
                        </Button>
                        )}
                        <Button
                          sx={{
                            position: 'relative',
                            minWidth: 100,
                            ml: 2.5,
                            borderColor: companyTheme
                              ? companyTheme.primary.main
                              : '#2196f3',
                            '&:hover': {
                              borderColor: companyTheme
                                ? alpha(companyTheme.primary.main, 0.8)
                                : alpha('#2196f3', 0.8),
                            },
                            color: companyTheme
                              ? companyTheme.primary.main
                              : '#2196f3',
                          }}
                          variant='outlined'
                          onClick={(e) => {
                            e.preventDefault();
                            // Reset the form back to its initial state
                            resetForm();
                          }}
                        >
                          <IntlMessages id='common.cancel' />
                        </Button>
                      </Box>
                    </Grid>
                  </AppGridContainer>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </Box>
      <AppInfoView />
    </>
  );
};

export default MessagePreferances;
MessagePreferances.propTypes = {
  companyTheme: PropTypes.object,
};
